// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ade7ee91","977":"1ed7e3bd"}[chunkId] + ".chunk.js";
};